import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {StockSharedModule} from "../stock/stock.shared.module";
import {AccountTypeSearchPageComponent} from "./account-type/account-type-search-page/account-type-search-page.component";
import {AccountSearchPageComponent} from "./account/account-search-page/account-search-page.component";
import {AccountTypeMultiSelectSearchControlComponent} from "./account-type/controls/account-type-multi-select-search-control.component";
import {FrameworkModule} from "../framework/framework.module";
import {AccountSharedModule} from "./account.shared.module";
import {AccountEditPageComponent} from "./account/account-edit-page/account-edit-page.component";
import {BillingCycleSingleSelectEditControlComponent} from "./account/controls/billing-cycle-single-select-edit-control.component";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {PosSharedModule} from "../pos/pos.shared.module";
import {ContactSharedModule} from "../contact/contact.shared.module";
import {AccountTypeEditPageComponent} from "./account-type/account-type-edit-page/account-type-edit-page.component";
import {AccountTypeEditDetailsComponent} from "./account-type/account-type-edit-page/account-type-edit-details/account-type-edit-details.component";
import {SystemSharedModule} from "../system/system.shared.module";
import {AccountTypeEditInvoicingStatementsComponent} from "./account-type/account-type-edit-page/account-type-edit-invoicing-statements/account-type-edit-invoicing-statements.component";
import {StatementAddressBlockTypeSingleSelectEditControlComponent} from "./account-type/controls/statement-address-block-type-single-select-edit-control.component";
import {AccountTypeEditBillingTermsComponent} from "./account-type/account-type-edit-page/account-type-edit-billing-terms/account-type-edit-billing-terms.component";
import {AccountTypeEditPaymentSettingsComponent} from "./account-type/account-type-edit-page/account-type-edit-payment-settings/account-type-edit-payment-settings.component";
import {AccountTypeEditOtherSettingsComponent} from "./account-type/account-type-edit-page/account-type-edit-other-settings/account-type-edit-other-settings.component";
import {AccountTypeEditDescriptionComponent} from "./account-type/account-type-edit-page/account-type-edit-description/account-type-edit-description.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {AccountSummaryReportComponent} from "./reports/account-summary-report/account-summary-report.component";
import {AccountReportSelectionControlComponent} from "./account/controls/account-report-selection-control.component";
import {EmployeeSharedModule} from "../employee/employee.shared.module";
import {CustomersSharedModule} from "../customers/customers.shared.module";
import {AccItemStmtReportComponent} from "./reports/acc-item-stmt-report/acc-item-stmt-report.component";
import {AccountPaymentSearchPageComponent} from "./account-payment/account-payment-search-page/account-payment-search-page.component";
import {AccountPaymentEditPageComponent} from "./account-payment/account-payment-edit-page/account-payment-edit-page.component";
import {AccountPaymentDetailsSingleSelectEditControlComponent} from "./account-payment/controls/account-payment-details-single-select-edit-control.component";
import {VoidAccountPaymentSearchActionComponent} from "./account-payment/actions/void-account-payment-search-action.component";
import {AccSingleInvReportComponent} from "./reports/acc-single-inv-report/acc-single-inv-report.component";
import {AccountInvoiceSearchPageComponent} from "./account-invoice/account-invoice-search-page/account-invoice-search-page.component";
import {AccountInvoiceAutocompleteEditControl} from "./account-invoice/controls/account-invoice-autocomplete-edit-control.component";
import {AccountLimitDurationSelectOptionsComponent} from "./account/controls/account-limit-duration-select-options.component";
import {AccountPaymentReceiptSearchActionComponent} from "./account-payment/actions/account-payment-receipt-search-action.component";
import {AccReceivableReportComponent} from "./reports/acc-receivable-report/acc-receivable-report.component";
import {OutgoingsReportComponent} from "./reports/outgoings-report/outgoings-report.component";
import {ExpAccDetailReportComponent} from "./reports/exp-acc-detail-report/exp-acc-detail-report.component";
import {ReportsSharedModule} from "../reports/reports.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        ReportsSharedModule,
        StockSharedModule,
        CustomObjectSharedModule,
        AccountSharedModule,
        PricingSharedModule,
        PosSharedModule,
        ContactSharedModule,
        SystemSharedModule,
        EmployeeSharedModule,
        CustomersSharedModule
    ],
    declarations: [
        AccountTypeSearchPageComponent,
        AccountSearchPageComponent,
        AccountTypeMultiSelectSearchControlComponent,
        AccountEditPageComponent,
        BillingCycleSingleSelectEditControlComponent,
        AccountTypeEditPageComponent,
        AccountTypeEditDetailsComponent,
        AccountTypeEditInvoicingStatementsComponent,
        AccountTypeEditBillingTermsComponent,
        AccountTypeEditPaymentSettingsComponent,
        AccountTypeEditOtherSettingsComponent,
        AccountTypeEditDescriptionComponent,
        AccountPaymentSearchPageComponent,
        AccountPaymentEditPageComponent,
        AccountPaymentDetailsSingleSelectEditControlComponent,
        StatementAddressBlockTypeSingleSelectEditControlComponent,
        AccountSummaryReportComponent,
        ExpAccDetailReportComponent,
        OutgoingsReportComponent,
        AccReceivableReportComponent,
        AccountReportSelectionControlComponent,
        AccItemStmtReportComponent,
        VoidAccountPaymentSearchActionComponent,
        AccountPaymentReceiptSearchActionComponent,
        AccSingleInvReportComponent,
        AccountInvoiceSearchPageComponent,
        AccountInvoiceAutocompleteEditControl,
        AccountLimitDurationSelectOptionsComponent
    ],
    exports: [
        AccountTypeSearchPageComponent,
        AccountSearchPageComponent,
        AccountTypeMultiSelectSearchControlComponent,
        AccountEditPageComponent,
        BillingCycleSingleSelectEditControlComponent,
        AccountTypeEditPageComponent,
        AccountTypeEditDetailsComponent,
        AccountTypeEditInvoicingStatementsComponent,
        AccountTypeEditBillingTermsComponent,
        AccountTypeEditPaymentSettingsComponent,
        AccountTypeEditOtherSettingsComponent,
        AccountTypeEditDescriptionComponent,
        AccountPaymentSearchPageComponent,
        AccountPaymentEditPageComponent,
        AccountPaymentDetailsSingleSelectEditControlComponent,
        StatementAddressBlockTypeSingleSelectEditControlComponent,
        AccountSummaryReportComponent,
        ExpAccDetailReportComponent,
        OutgoingsReportComponent,
        AccReceivableReportComponent,
        AccountReportSelectionControlComponent,
        AccItemStmtReportComponent,
        VoidAccountPaymentSearchActionComponent,
        AccountPaymentReceiptSearchActionComponent,
        AccSingleInvReportComponent,
        AccountInvoiceSearchPageComponent,
        AccountInvoiceAutocompleteEditControl,
        AccountLimitDurationSelectOptionsComponent
    ]
})
export class AccountModule {

}
